import clientUUID from '@/client.js';
import {domain, queryParams} from '@/modules/common.js';
import {platform} from '@/config.js';

const encodedPlatforms = ['ios', 'mac'];

export const routeDecoder = data => encodedPlatforms.includes(platform) ? JSON.parse(data) : data;

export const tipuri = [
  'noutate',
  'document-discutie',
  'buletin-informativ'
];

export const topics = Object.defineProperties(
  {
    'noutate': 'noutati_label',
    'document-discutie': 'documente_discutie_label',
    'buletin-informativ': 'buletine_informative_label',
  },
  {
    'debug': {
      value: 'debug_topic_label',
      enumerable: process.env.VUE_APP_DEBUG === 'true' || process.env.VUE_APP_DEBUG === '1'
    }
  }
);

export const index = (lang, tip, filters = {}) => fetch(`${domain}/${lang}/noutati/${tip}?${queryParams(filters)}`, {
  method: 'get',
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
    'X-Client-UUID': clientUUID
  }
});

export const find = (lang, id) => fetch(`${domain}/${lang}/noutati/${id}`, {
  method: 'get',
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
    'X-Client-UUID': clientUUID
  }
});

export const unreadCount = (lang, since) => fetch(`${domain}/${lang}/noutati/unread-count`, {
  method: 'post',
  body: JSON.stringify({
    since
  }),
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
    'X-Client-UUID': clientUUID
  }
});
